"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeMMED = function CategoryCodeMMED(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeMMED"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M10.273,6.769,6.543,4.576A.412.412,0,0,0,6.1,4.569a.42.42,0,0,0-.219.384V9.34a.42.42,0,0,0,.219.384.487.487,0,0,0,.22.055.42.42,0,0,0,.219-.062l3.73-2.193a.435.435,0,0,0,0-.755Z"
  }), _react.default.createElement("path", {
    d: "M7.226,10.853a3.607,3.607,0,0,1-1.458-.478A3.718,3.718,0,0,1,4.411,9.018a3.753,3.753,0,0,1,0-3.743A3.718,3.718,0,0,1,5.768,3.918a3.748,3.748,0,0,1,3.744,0,3.718,3.718,0,0,1,1.357,1.357,3.64,3.64,0,0,1,.5,1.871c0,.123-.007.243-.018.362a.741.741,0,0,1,.234.157l1.077,1.078a5.275,5.275,0,0,0,.243-1.6A5.144,5.144,0,0,0,12.2,4.5a5.232,5.232,0,0,0-1.916-1.916A5.151,5.151,0,0,0,7.64,1.881,5.151,5.151,0,0,0,5,2.588,5.24,5.24,0,0,0,3.081,4.5a5.144,5.144,0,0,0-.706,2.642,5.145,5.145,0,0,0,.706,2.643A5.24,5.24,0,0,0,5,11.705a5.107,5.107,0,0,0,1.524.59,7.434,7.434,0,0,1,.691-1.422Z"
  }), _react.default.createElement("path", {
    d: "M11.138,8.112a.09.09,0,0,0-.065-.027.091.091,0,0,0-.092.092v.738a.092.092,0,0,1-.073.09A5.094,5.094,0,0,0,7.746,11.21a7.549,7.549,0,0,0-1.018,2.8.091.091,0,0,0,.091.106.093.093,0,0,0,.076-.041,4.433,4.433,0,0,1,1.361-1.232,4.986,4.986,0,0,1,2.473-.6c.151,0,.24.007.24.007v.855a.092.092,0,0,0,.093.092.088.088,0,0,0,.064-.027L13.6,10.7a.092.092,0,0,0,0-.13Z"
  }))));
};

var _default = CategoryCodeMMED;
exports.default = _default;